import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';
import {getBreakLinesTextShumaType3WithoutDot} from "../../../utils/texts";

const Section6Text3 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {landDescription} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(landDescription) && (
        <div className={classnames(styles.itemText, styles.innerPadding, styles.lastSectionLine)}>
          <span className={styles.bold}>תיאור המגרש: </span>
          <span>{getBreakLinesTextShumaType3WithoutDot(landDescription)}</span>
        </div>
      )}
    </div>
  );
});

export default Section6Text3;